// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { HorizontalBar, defaults, Bar } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true,
    onClick: null
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Race/Ethnicity"
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          //set the labels to stack when they're too long
          //so they don't overflow out of the card
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label;
              } else {
                return label.split(" ");
              }
            } else {
              return label;
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Students who Identify"
        }
      }
    ]
  },
  title: {
    display: false,
    text: "UCLA vs. Daily Bruin Race/Ethnicity BreakdowN"
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface EthnicityBarChartProps {
  caption1: string;
  caption2: string;
}

class EthnicityBreakdownBarChartCard extends React.Component<EthnicityBarChartProps> {
  constructor(props: EthnicityBarChartProps){
    super(props);
  }
  state = {
    //using this as the data
    //dummy data for testing just in case
    labels: ["Black or African American", "White", "Hispanic or Latino", "Native American or American Indian", "Asian/Pacific Islander", "Middle Eastern (not recorded by UCLA)", "Multiracial", "Unknown/Prefer not to say"],
    borderWidth: 1,
    datasets: [
      { data: [3.11, 26.85, 13.49, .16, 37.3, 0, 15.11, 3.98], backgroundColor: "#48A2D3", label: "UCLA Fall 2021 Undergraduates" },
      { data: [2.2, 30.4, 7.5, 0.3, 45.8, 0.5, 7.8, 0.9], backgroundColor: "#F0A202", label: "Daily Bruin Staff" }
    ]
  };

  render() {
    const caption1 = this.props.caption1
    const caption2 = this.props.caption2
    defaults.global.defaultFontColor = "#0a0a0a";

    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Race/Ethnicity Breakdown
        </div>
        <div
          className={css`
            height: 400px;
            width: 100%;
          `}
        >
          <Bar
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: center;
          `}
        >
            {caption1}
            <br></br><br></br>
            {caption2}
        </div>
      </Card>
    );
  }
}

export default EthnicityBreakdownBarChartCard;
